<template>
    <div class="p-4">
        <b-field label="Title">
            <b-input
                v-model="category.title"
                placeholder="Category title"
                maxlength="200"
            ></b-input>
        </b-field>

        <b-field label="Description" :message="isSubcategory ? 'Optional description for this subcategory' : 'Optional description for this category'">
            <b-input
                v-model="category.description"
                type="textarea"
                placeholder="Optional description..."
                maxlength="1000"
                rows="3"
            ></b-input>
        </b-field>

        <b-field label="Sort Order" message="Lower numbers appear first">
            <b-numberinput
                v-model="category.sort"
                :min="0"
                :max="9999"
                controls-position="compact"
            ></b-numberinput>
        </b-field>
    </div>
</template>

<script>
export default {
    props: {
        category: {
            type: Object,
            required: true
        },
        isSubcategory: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.p-4 {
    padding: 1rem;
}
</style>
